export const parseQueryStringParams = (search?: string) => {
    return new URLSearchParams(search ?? window.location.search)
}
